import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './BioInfoDataForm.html?raw';
import on from 'dojo/on';
import Editor from 'dijit/Editor';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';

class BioInfoDataForm extends compose(_WidgetBaseSP) {
    templateString: any = template;
    isReadonly: boolean = false;
    isDirty: boolean = false;

    sectionName: string = "";

    bioEditorContainer: HTMLElement;
    editor: any;

    bioDataFormErrorContainer: HTMLElement;
    bioDataFormErrorMessage: HTMLElement;

    formData: IndividualData_Bio = {
        bio_html: ""
    };
    originalData: string = "";

    loadFormData(data: IndividualData_Bio): void {

        this.formData.bio_html = data.bio_html;
        this.originalData = JSON.stringify(this.formData);
        console.debug(this.originalData);

        this.editor = new Editor();
        this.editor.isTabIndent = true;
        this.editor.placeAt(this.bioEditorContainer);

        if (data.bio_html) this.editor.value = data.bio_html;
        
        this.editor.startup();

        on(this.editor, "change", lang.hitch(this, this._onChangeBioDataInput));
        on(this.editor, "keyup", lang.hitch(this, this._onChangeBioDataInput));
        
        this.serializeFormData();
    }

    serializeFormData(): void {

        this.formData.bio_html = this.editor.get("value");

        console.debug("SERIALIZE DATA:", this.formData);
        this.checkDirty();
        console.debug("isDirty:", this.isDirty);
    }

    _onClick_saveBtn(): void {

        if (this.isDirty) {

            let requestUrl = window.appRoot + "IndividualDataSheet/SaveBioWithHtmlFormData";
            this.StandbyStart();

            //console.debug("TEST", e);&nbsp;&nbsp;&nbsp;&nbsp;

            //this.formData.bio_html = window.btoa(this.formData.bio_html.replace(":::TEST:::", "&nbsp;&nbsp;&nbsp;&nbsp;"));
            
            this.RequestManager.post(
                requestUrl,
                {
                    jsonData: JSON.stringify(this.formData),
                    sectionName: this.sectionName
                },
                lang.hitch(this, this._onSaveFormDataResponse),
                lang.hitch(this, this._onSaveFormDataError),
                false // sync
            );
        }
    }

    _onSaveFormDataResponse(): void {

        this.StandbyStop();

        let dlg = new GenericDialog();

        dlg.destroyOnClose = true;
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "width", "600px");
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "margin-top", "100px");

        dlg.show(this.translations["FormDialog_Save_Message"], this.translations["FormDialog_Save_Header"], null, "fas fa-info-circle", "ok");

        this.emit("DataForm_close");
    }

    checkDirty(): void {

        this.isDirty = JSON.stringify(this.formData) !== this.originalData;

        this.emit("change_isDirty", this.isDirty);
    }

    _onChangeBioDataInput(): void {

        this.serializeFormData();
    }

    _onSaveFormDataError(err): void {

        this.StandbyStop();
        console.error(err);
        this.showErrorMessage(true, err.Message);
    }

    showErrorMessage(bool: boolean, msg?: string) {

        if (bool) {

            this.UiModder.domClass.remove(this.bioDataFormErrorContainer, "w3-hide");
            msg ? this.bioDataFormErrorMessage.innerHTML = msg : this.bioDataFormErrorMessage.innerHTML = "...error occured";
        } else {

            this.UiModder.domClass.add(this.bioDataFormErrorContainer, "w3-hide");
            this.bioDataFormErrorMessage.innerHTML = "";
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(BioInfoDataForm);